import { Auth as AuthTypes } from '../types'

const {
  REQUEST_LOGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  RESET_AUTH,
  LOGOUT
} = AuthTypes

const initialState = {
  token: null,
  isLoading: false,
  errors: {
    status: false,
    message: null
  }
}

export default (state = initialState, action) => {
  switch (action.type) {

    case REQUEST_LOGIN:
      return {
        ...state,
        isLoading: true,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        isLoading: false,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    case LOGIN_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          status: true,
          message: action.payload.message
        }
      }

    case RESET_AUTH:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          status: false,
          message: null
        }
      }

    case LOGOUT:
      return {
        ...state,
        token: null
      }

    default:
      return state

  }
}
